import React, { useEffect, useState, useRef } from "react";
import {
  ButtonContainer,
  ChartContainer,
  EstiloAprendizajeHeader,
  EstiloNaturalDecisionAnswers,
  EstiloNaturalDecisionContainerStyled,
  EstiloNaturalDecisionQuestion,
  EstiloNaturalDecisionQuestionTitle,
  EstiloNaturalDecisionQuestionsContainer,
  LogoContainer,
  TextContainer,
} from "./EstiloNaturalDecisionStyles";

import urlImageContinue from "../../assets/images/estilo-natural-decision/continue-button.png";
import urlImageNext from "../../assets/images/estilo-natural-decision/next-button.png";
import urlImageView from "../../assets/images/estilo-natural-decision/view-button.png";
import urlImageEnd from "../../assets/images/estilo-natural-decision/end-button.png";
import axios, { EnpointsUrlBase } from "../../helpers/axios";
import { useSearchParams } from "react-router-dom";

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  Filler,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  Filler
);

export enum PasosEstiloNaturalDecision {
  Instrucciones = 1,
  Preguntas = 2,
  Informe = 3,
}

const EstiloNaturalDecisionContainer = () => {
  const chartRef = useRef<any>(null);

  const [currentStep, setCurrentStep] = useState<PasosEstiloNaturalDecision>(
    PasosEstiloNaturalDecision.Instrucciones
  );

  const [preguntas, setPreguntas] = useState<any[]>([]);
  const [encabezado, setEncabezado] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [guardandoRespuestas, setGuardandoRespuestas] = useState(false);
  const [preguntaActual, setPreguntaActual] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [respuestas, setRespuestas] = useState<any[]>([]);
  const [lineCoordinates, setLineCoordinates] = useState<any>([]);
  const [searchParams] = useSearchParams();

  const idUsuario = searchParams.get("i") || "";
  const nombreUsuario = searchParams.get("u") || "";
  const empresa = searchParams.get("e") || "";
  const email = searchParams.get("m") || "";
  const programa = searchParams.get("p") || "";
  const intento = searchParams.get("ip") || 1;
  const hr = searchParams.get("hr") || "0";
  const sobreEscribir = searchParams.get("se") || "false";
  const [chartData, setChartData] = useState<any>({});
  const [generateAfterSave, setGenerateAfterSave] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);

  const handleContinue = () => {
    setCurrentStep(PasosEstiloNaturalDecision.Preguntas);
  };

  const handleFinalize = () => {
    if (selectedOption === "") {
      return;
    }

    if (preguntaActual + 1 == preguntas.length) {
      const respuesta = {
        afirmacionId: preguntas[preguntaActual].id,
        respuesta: selectedOption,
      };
      setRespuestas([...respuestas, respuesta]);
      if (guardandoRespuestas === true) return;
      setGuardandoRespuestas(true);
      axios
        .post(
          `${EnpointsUrlBase}/EstiloNaturalDecision/GrabarRespuestas`,
          {
            respuestas: [...respuestas, respuesta],
            idUsuario: idUsuario,
            nombreUsuario: nombreUsuario,
            empresaUsuario: empresa,
            emailUsuario: email,
            programaUsuario: programa,
            intento: intento,
          },
          (res: any, data: any) => {
            if (res === 200) {
              setCurrentStep(PasosEstiloNaturalDecision.Informe);
              setEncabezado(data);
              console.log("hr", hr);
              if (hr === "0") {
                if (isFirstTime) setGenerateAfterSave(true);
                setIsFirstTime(false);
              }
            }
            setGuardandoRespuestas(false);
          }
        )
        .catch(() => {
          setGuardandoRespuestas(false);
          console.error(
            "No se pudieron guardar las respuestas, por favor intente nuevamente."
          );
        });
    }
  };

  const handleViewReport = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "JWT fefege...",
    };

    axios.getH(
      `${EnpointsUrlBase}/EstiloNaturalDecision/GenerarInforme/${encabezado.id}`,
      {
        headers: {
          "Content-Type": "application/pdf",
        },
      },
      (res: any, data: any) => {
        if (res === 200) {
          const url = window.URL.createObjectURL(new Blob([data]));

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Estilo Natural de Decisión (${nombreUsuario}) - (${programa}).pdf`
          );

          document.body.appendChild(link);
          link.click();
          link?.parentNode?.removeChild(link);
        }
      }
    );
  };

  const handleNextQuestion = () => {
    if (selectedOption === "") {
      return;
    }

    if (preguntaActual + 1 < preguntas.length) {
      const respuesta = {
        afirmacionId: preguntas[preguntaActual].id,
        respuesta: selectedOption,
      };
      setRespuestas([...respuestas, respuesta]);

      setPreguntaActual(preguntaActual + 1);
      handleReset();
    } else {
      if (preguntaActual + 1 == preguntas.length) {
        const respuesta = {
          afirmacionId: preguntas[preguntaActual].id,
          respuesta: selectedOption,
        };
        setRespuestas([...respuestas, respuesta]);
        if (guardandoRespuestas === true) return;
        setGuardandoRespuestas(true);
        axios
          .post(
            `${EnpointsUrlBase}/EstiloNaturalDecision/GrabarRespuestas`,
            {
              respuestas: [...respuestas, respuesta],
              idUsuario: idUsuario,
              nombreUsuario: nombreUsuario,
              empresaUsuario: empresa,
              emailUsuario: email,
              programaUsuario: programa,
              intento: intento,
            },
            (res: any, data: any) => {
              setGuardandoRespuestas(false);
              if (res === 200) {
                setCurrentStep(PasosEstiloNaturalDecision.Informe);
              } else {
                console.error(
                  "No se pudo guardar la respuesta, por favor intente nuevamente."
                );
              }
            }
          )
          .catch(() => {
            setGuardandoRespuestas(false);
          });
      }
    }
  };

  const handleOptionChange = (event: any) => {
    setSelectedOption(event.target.value);
  };

  const handleReset = () => {
    setSelectedOption("");
  };

  useEffect(() => {
    const getPreguntas = () => {
      setLoading(true);
      axios.get(
        `${EnpointsUrlBase}/EstiloNaturalDecision/GetPreguntas` +
          window.location.search,
        (res: any, data: any) => {
          if (res === 200) {
            if (Array.isArray(data) && data.length > 1) {
              setPreguntas(data);
              setPreguntaActual(0);
            } else {
              setCurrentStep(PasosEstiloNaturalDecision.Informe);
              setEncabezado(data);
            }
          }
          setLoading(false);
        }
      );
    };

    getPreguntas();
  }, []);

  useEffect(() => {
    if (encabezado && encabezado.id && encabezado.letrasInforme) {
      const dEIndex = 1;
      const DEIndex = 7;
      const DIIndex = 5;
      const dIIndex = 3;

      // Aplicar valor mínimo de 1 para evitar que los triángulos se colapsen
      const dEValue = encabezado.dE > 0 ? encabezado.dE : 1;
      const DEValue = encabezado.DE > 0 ? encabezado.DE : 1;
      const dIValue = encabezado.dI > 0 ? encabezado.dI : 1;
      const DIValue = encabezado.DI > 0 ? encabezado.DI : 1;

      const lineCoordinates = [
        {
          x1: dEIndex,
          y1: dEValue,
          x2: DEIndex,
          y2: DEValue,
        },
        {
          x1: DIIndex,
          y1: DIValue,
          x2: dIIndex,
          y2: dIValue,
        },
      ];

      setLineCoordinates(lineCoordinates);

      setChartData({
        labels: [
          "", //Eficiente
          "dE",
          "", //Delegador
          "dI",
          "", //Ineficiente
          "DI",
          "", //Directivo
          "DE",
        ],
        datasets: [
          {
            label: "Line 1",
            data: [null, dEValue, null, null, null, null, null, DEValue],
            backgroundColor: "blue",
            borderColor: "green",
            fill: true,
            borderWidth: 1,
            spanGaps: true,
          },
          {
            label: "Line 11",
            data: [null, dEValue, null, null, null, null, null, 0],
            backgroundColor: "blue",
            borderColor: "green",
            fill: true,
            borderWidth: 1,
            spanGaps: true,
          },
          {
            label: "Line 12",
            data: [null, 0, null, null, null, null, null, DEValue],
            backgroundColor: "blue",
            borderColor: "green",
            fill: true,
            borderWidth: 1,
            spanGaps: true,
          },
          {
            label: "Line 2",
            data: [null, null, null, dIValue, null, DIValue, null, null],
            backgroundColor: "rgba(255, 0, 0, 0.2)", // Light red fill
            borderColor: "red",
            fill: true,
            borderWidth: 1,
            spanGaps: true,
          },
          {
            label: "Line 21",
            data: [null, null, null, dIValue, null, 0, null, null],
            backgroundColor: "rgba(255, 0, 0, 0.2)", // Light red fill
            borderColor: "red",
            fill: true,
            borderWidth: 1,
            spanGaps: true,
          },
          {
            label: "Line 22",
            data: [null, null, null, 0, null, DIValue, null, null],
            backgroundColor: "rgba(255, 0, 0, 0.2)", // Light red fill
            borderColor: "red",
            fill: true,
            borderWidth: 1,
            spanGaps: true,
          },
          {
            label: "Ineficiencia",
            data: [null, null, null, 24, 24, 24, null, null],
            backgroundColor: "rgba(255, 184, 199, 0.2)",
            borderColor: "transparent",
            fill: true,
            borderWidth: 1,
          },
          {
            label: "Eficiencia",
            data: [24, 24, null, null, null, null, null, 24],
            backgroundColor: "rgba(184, 255, 202, 0.2)",
            borderColor: "transparent",
            fill: true,
            borderWidth: 1,
          },
        ],
      });
    }
  }, [encabezado]);

  const chartOptions = {
    elements: {
      line: {
        tension: 0,
        borderWidth: 1,
      },
      point: {
        radius: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      r: {
        min: 0,
        ticks: {
          stepSize: 5,
        },
        angleLines: {
          display: true,
        },
        grid: {
          circular: true,
        },
      },
    },
    animation: {
      onComplete: () => {
        if (encabezado.id && chartRef?.current?.toBase64Image()) {
          // Construir la URL con el parámetro sobrerescribir si existe
          const searchParams = new URLSearchParams(window.location.search);
          const sobrerescribir = searchParams.get("se");
          const queryParam =
            sobrerescribir === "true" ? "?sobrerescribir=true" : "";

          axios.post(
            `${EnpointsUrlBase}/EstiloNaturalDecision/GuardarGrafico${queryParam}`,
            {
              encabezadoId: encabezado.id,
              graficoBase64: chartRef?.current?.toBase64Image(),
            },
            (res: any) => {
              if (res === 200) {
                if (generateAfterSave) {
                  setGenerateAfterSave(false);
                  handleViewReport();
                }
                console.log("Chart saved successfully");
              } else {
                console.error("Error saving the chart");
              }
            }
          );
        }
      },
    },
  };

  type Code = "A1" | "A2" | "A3" | "B1" | "B2" | "B3";

  const getDescription = (code: Code): string => {
    const descriptions: Record<Code, string> = {
      A1: "Estilo Directivo Eficiente y Flexible",
      A2: "Estilo Directivo Eficaz",
      A3: "Estilo Directivo Natural e Inflexible",
      B1: "Estilo Delegador Eficiente y Flexible",
      B2: "Estilo Delegador Eficaz",
      B3: "Estilo Delegador Natural",
    };

    return descriptions[code] || "Descripción no encontrada";
  };

  return (
    <EstiloNaturalDecisionContainerStyled paso={currentStep}>
      <EstiloAprendizajeHeader>
        <TextContainer>
          <div className="introspeccion">Introspección</div>
          <div>
            <span className="estilo">Estilo </span>
            <span className="natural">Natural de </span>
            <span className="decision">Decisión</span>
          </div>
        </TextContainer>
        <LogoContainer>
          {currentStep !== PasosEstiloNaturalDecision.Preguntas && (
            <>
              <img
                className="logoleft"
                src={
                  require(`../../assets/images/estilo-aprendizaje/logos/1/logoleft.svg`)
                    .default
                }
                alt=""
              />
              <img
                className="logoright"
                src={
                  require(`../../assets/images/estilo-aprendizaje/logos/1/logoright.svg`)
                    .default
                }
                alt=""
              />
            </>
          )}
          {currentStep === PasosEstiloNaturalDecision.Preguntas && (
            <>
              <img
                className="logoleft"
                src={
                  require(`../../assets/images/estilo-aprendizaje/logos/1/logoleft-blue.svg`)
                    .default
                }
                alt=""
              />
              <img
                className="logoright"
                src={
                  require(`../../assets/images/estilo-aprendizaje/logos/1/logoright-blue.svg`)
                    .default
                }
                alt=""
              />
            </>
          )}
        </LogoContainer>
      </EstiloAprendizajeHeader>

      {currentStep === PasosEstiloNaturalDecision.Preguntas && (
        <EstiloNaturalDecisionQuestionTitle number={preguntaActual + 1}>
          <span>{preguntas[preguntaActual].titulo}</span>
        </EstiloNaturalDecisionQuestionTitle>
      )}
      {loading && <div style={{ color: "white" }}>Cargando...</div>}

      {!loading && (
        <EstiloNaturalDecisionQuestionsContainer>
          {currentStep === PasosEstiloNaturalDecision.Instrucciones && (
            <div>
              <h1>Introducción</h1>
              <p>
                Los criterios que usamos para tomar decisiones, la forma cómo
                involucramos los equipos en las diferentes situaciones, entre
                otros aspectos que están implícitos en cada decisión que tomamos
                como líderes, determinan nuestro
                <strong> estilo natural de decisión.</strong>
              </p>
              <p>
                Por medio de este test, se busca identificar cuál es tu estilo
                natural, y cómo conociéndolo, puedes apalancar y potenciar desde
                tus fortalezas aquellos aspectos que ponen en riesgo la
                coherencia, la agilidad, el empoderamiento y el compromiso de tu
                equipo de trabajo.
              </p>
              <h1>Instrucciones</h1>
              <div>
                <p>
                  Para la elaboración de la prueba, se proponen
                  <strong> 12 situaciones</strong>
                </p>

                <ul>
                  <li>
                    Identifica la <strong>situación</strong> concreta que se
                    plantea.
                  </li>
                  <li>
                    <strong>Empatiza</strong> con el responsable de la decisión.
                    Asume que tienes la responsabilidad y posees el conocimiento
                    que debes tener como líder en cada situación.
                  </li>
                  <li>
                    <strong>Valora</strong> cada situación, eligiendo una entre
                    las 4 <strong>alternativas de decisión</strong> que se
                    presentan en cada caso.
                  </li>
                  <li>
                    Una vez resueltas individualmente las 12 situaciones
                    hipotéticas, podremos estimar con fiabilidad cuál es tu
                    estilo natural de decisión.
                    <strong> Analiza y descarga </strong>el informe de tu
                    resultado.
                  </li>
                </ul>
              </div>
            </div>
          )}

          {currentStep === PasosEstiloNaturalDecision.Preguntas && (
            <>
              <EstiloNaturalDecisionQuestion
                dangerouslySetInnerHTML={{
                  __html: `${preguntas[preguntaActual].descripcion}`,
                }}
              ></EstiloNaturalDecisionQuestion>
              <EstiloNaturalDecisionAnswers>
                <ul>
                  <li>
                    <input
                      type="radio"
                      name="pregunta"
                      id="pre1"
                      value="A"
                      checked={selectedOption === "A"}
                      onChange={handleOptionChange}
                    />
                    <span className="marker">A</span>
                    <label
                      htmlFor="pre1"
                      dangerouslySetInnerHTML={{
                        __html: `${preguntas[preguntaActual].opcionA}`,
                      }}
                    ></label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="pregunta"
                      id="pre2"
                      value="B"
                      checked={selectedOption === "B"}
                      onChange={handleOptionChange}
                    />
                    <span className="marker">B</span>

                    <label
                      htmlFor="pre2"
                      dangerouslySetInnerHTML={{
                        __html: `${preguntas[preguntaActual].opcionB}`,
                      }}
                    ></label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="pregunta"
                      id="pre3"
                      value="C"
                      checked={selectedOption === "C"}
                      onChange={handleOptionChange}
                    />
                    <span className="marker">C</span>
                    <label
                      htmlFor="pre3"
                      dangerouslySetInnerHTML={{
                        __html: `${preguntas[preguntaActual].opcionC}`,
                      }}
                    ></label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="pregunta"
                      id="pre4"
                      value="D"
                      checked={selectedOption === "D"}
                      onChange={handleOptionChange}
                    />

                    <span className="marker">D</span>
                    <label
                      htmlFor="pre4"
                      dangerouslySetInnerHTML={{
                        __html: `${preguntas[preguntaActual].opcionD}`,
                      }}
                    ></label>
                  </li>
                </ul>
              </EstiloNaturalDecisionAnswers>
            </>
          )}

          {currentStep === PasosEstiloNaturalDecision.Informe &&
            encabezado &&
            encabezado.letrasInforme &&
            chartData?.labels?.length > 0 && (
              <>
                <div
                  style={{
                    display: "flex",
                    maxHeight: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "0",
                    flexWrap: "wrap",
                    gap: 30,
                  }}
                >
                  <div>
                    {encabezado.letrasInforme && (
                      <h1
                        style={{
                          margin: 0,
                          fontSize: "18px",
                          textAlign: "center",
                        }}
                      >
                        <span
                          style={{
                            color: "rgb(182, 184, 50)",
                          }}
                        >
                          {encabezado.letrasInforme}:{" "}
                        </span>
                        <span
                          style={{
                            color: "white",
                          }}
                        >
                          {getDescription(encabezado.letrasInforme)}
                        </span>
                      </h1>
                    )}
                    <ChartContainer>
                      <div>
                        <Chart
                          ref={chartRef}
                          type="radar"
                          data={chartData}
                          options={chartOptions}
                        />
                      </div>

                      <div
                        id="radarToExport"
                        style={{
                          position: "absolute",
                          left: "-2000px",
                          width: "400px",
                          height: "400px",
                        }}
                      >
                        <Chart
                          ref={chartRef}
                          type="radar"
                          data={chartData}
                          options={chartOptions}
                        />
                      </div>
                    </ChartContainer>
                  </div>

                  <div>
                    Descarga tu informe completo de la introspección, dando clic
                    en el botón <strong>"Ver informe"</strong>
                  </div>
                </div>
              </>
            )}
        </EstiloNaturalDecisionQuestionsContainer>
      )}
      {!loading && guardandoRespuestas === false && (
        <ButtonContainer>
          {currentStep === PasosEstiloNaturalDecision.Preguntas && (
            <>
              {preguntaActual !== preguntas.length - 1 && (
                <img src={urlImageNext} alt="" onClick={handleNextQuestion} />
              )}
              {preguntaActual === preguntas.length - 1 && (
                <img src={urlImageEnd} alt="" onClick={handleFinalize} />
              )}
            </>
          )}
          {currentStep === PasosEstiloNaturalDecision.Instrucciones && (
            <img src={urlImageContinue} alt="" onClick={handleContinue} />
          )}
          {currentStep === PasosEstiloNaturalDecision.Informe && (
            <img src={urlImageView} alt="" onClick={handleViewReport} />
          )}
        </ButtonContainer>
      )}
      {guardandoRespuestas === true && (
        <ButtonContainer>Guardando...</ButtonContainer>
      )}
    </EstiloNaturalDecisionContainerStyled>
  );
};

export default EstiloNaturalDecisionContainer;
